import React, { Component } from 'react';
import { connect } from 'react-redux';
import Autocomplete from 'react-autocomplete';
import Modal from '../../../components/Modal';
import updateState from '../../../utils/updateState';
import { fetchColaboradores, clearColaboradores } from '../../../actions';

const menuStyle = {
  position: 'absolute',
  left: '0',
  top: '100%',
  maxHeight: '350px',
  overflow: 'auto',
  border: '1px solid #cccccc',
};

const inputProps = {
  className: 'form-control awesomplete pillSelct-input',
  name: 'colaborador',
};

class Estado extends Component {
  constructor(props) {
    super(props);

    this.state = {
      codigoEstado: 'X',
      observacion: '',
      colaborador: '',
      colaboradores: [],
      validInput: true,
    };
  }

  onChangeValue = e => this.setState({ [e.target.name]: e.target.value, validInput: true })

  changeColaborador = (e) => {
    this.onChangeValue(e);
    if (e.target.value.length >= 2) {
      this.props.fetchColaboradores(e.target.value);
    } else if (e.target.value.length === 0) {
      this.props.clearColaboradores();
    }
  }

  selectColaborador = (key) => {
    const { colaboradores } = this.state;
    const colaboradorSelected = colaboradores.filter(colaborador => colaborador.id === key).length;

    if (!colaboradorSelected) {
      const nombres = this.props.colaboradores
      .filter(({ idUsuario }) => idUsuario.toString() === key)[0].nombre;

      const apellidos = this.props.colaboradores
      .filter(({ idUsuario }) => idUsuario.toString() === key)[0].apellidos;
      const colaborador = { id: key, nombres: `${apellidos} ${nombres}` };

      this.setState({ colaborador: '', colaboradores: [...this.state.colaboradores, colaborador] });
      this.props.clearColaboradores();
    }
  }

  removeColaborador = (id) => {
    const { colaboradores } = this.state;
    this.setState({ colaboradores: colaboradores.filter(colaborador => id !== colaborador.id) });
  }

  changeStatus = () => {
    const { fdvID } = this.props;
    const { codigoEstado, observacion, colaboradores } = this.state;
    const colaboradoresId = colaboradores.map(({ id }) => id);

    if (codigoEstado === 'X') {
      this.setState({ validInput: false });
    } else {
      this.props.closeModal();
      updateState(fdvID, codigoEstado, observacion, colaboradoresId)
      .then(({ data }) => {
        this.props.fetchFichaVenta(fdvID);
        this.props.openAlert(data);
      });
    }
  }

  render() {
    const { codigoEstado, observacion, validInput } = this.state;
    const inputError = validInput ? 'error' : 'error js-open';

    return (
      <Modal title='Cambiar estado de ficha' idModal='fdv-cambiarEstado' isOpen closeModal={this.props.closeModal} modalSize='modal-sm little-modal modal-margin-top'>
        <div className='form-group'>
          <span className='labelInfo'>Elige un nuevo estado</span>
          <div className='select'>
            <select className='form-control' id='selectEstado' value={codigoEstado} onChange={this.onChangeValue} name='codigoEstado'>
              <option value='X' disabled>Selecciona un estado</option>
              {
                this.props.estados.map(estado =>
                  <option value={estado.codEstadoFichaVta} key={estado.codEstadoFichaVta}>
                    {estado.desEstadoFichaVta}
                  </option>
                )
              }
            </select>
            <div className='select-control-icon'><i className='ion-arrow-down-b' /></div>
          </div>
          <span className={inputError}>El estado es requerido</span>
        </div>
        <div className='form-group'>
          <div className='form-group'>
            <label className='labelInfo' htmlFor='observacion'>Observaciones</label>
            <textarea className='form-control' id='observacion' name='observacion' value={observacion} onChange={this.onChangeValue} maxLength='300' />
          </div>
        </div>
        <div className='form-group'>
          <div className='pillSelct'>
            <p className='labelInfo'>Notificar a un colaborador</p>
            <div className='pillSelct-field'>
              <div className='awesomplete'>
                <Autocomplete
                  getItemValue={item => item.idUsuario.toString()}
                  value={this.state.colaborador}
                  items={this.props.colaboradores}
                  renderItem={(item, isHighlighted) =>
                    <div key={item.idUsuario} style={{ background: isHighlighted ? 'lightgray' : 'white', padding: '6px 12px' }}>
                      {`${item.apellidos} ${item.nombre}`}
                    </div>
                  }
                  onChange={this.changeColaborador}
                  menuStyle={menuStyle}
                  inputProps={inputProps}
                  wrapperStyle={{ display: 'block' }}
                  onSelect={this.selectColaborador}
                />
              </div>
              <div className='pillSelct-pills'>
                {
                  this.state.colaboradores.map(colaborador => (
                    <label className='pill pill-cyan pillSelct-pills-item' htmlFor='colaborador'>
                      {colaborador.nombres}
                      <button
                        className='pillSelct-delete'
                        onClick={() => this.removeColaborador(colaborador.id)}
                      ><i className='icon ion-close pill-close' />
                      </button>
                    </label>
                  ))
                }
              </div>
            </div>
          </div>
        </div>
        <div className='modal-actions'>
          <button className='btn btn-return' onClick={this.props.closeModal}>Cancelar</button>
          <button className='btn btn-primary pull-right' onClick={this.changeStatus}>Aceptar</button>
        </div>
      </Modal>
    );
  }
}

Estado.defaultProps = {
  isOpen: false,
  estados: [],
  estado: '',
};

function mapStateToProps(state) {
  return {
    colaboradores: state.colaboradores,
  };
}

export default connect(mapStateToProps, { fetchColaboradores, clearColaboradores })(Estado);



// WEBPACK FOOTER //
// ./src/pages/modals/Estado/index.js